import Box from '@mui/material/Box'
import Skeleton from '@mui/material/Skeleton'
import Stack from '@mui/material/Stack'

export default function SkeletonSeriesDetail() {
    return (
        <Stack spacing={2} sx={{ width: '100%' }}>
            <Stack
                direction="row"
                spacing={2}
                sx={{
                    px: 2,
                    py: 1.5,
                    bgcolor: 'primary.main',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                }}
            >
                <Skeleton
                    variant="text"
                    width={200}
                    sx={{ fontSize: '1.5rem', bgcolor: 'grey.300' }}
                />
                <Skeleton variant="circular" width={20} height={20} sx={{ bgcolor: 'grey.300' }} />
            </Stack>

            <Stack direction="row" spacing={2} sx={{ alignItems: 'center', px: 1 }}>
                <Skeleton variant="rounded" height={56} sx={{ flexGrow: 1 }} />
                <Skeleton variant="rounded" width={110} height={28} />
            </Stack>

            <Box sx={{ px: 1 }}>
                <Skeleton variant="rounded" height={56} />
            </Box>

            <Box sx={{ px: 1 }}>
                <Box sx={{ border: '1px solid', borderColor: 'divider', borderRadius: 1 }}>
                    <Stack
                        direction="row"
                        spacing={3}
                        sx={{
                            px: 2,
                            py: 1.5,
                            borderBottom: '1px solid',
                            borderColor: 'divider',
                        }}
                    >
                        <Skeleton variant="text" width={80} />
                        <Skeleton variant="text" width={70} />
                        <Skeleton variant="text" width={110} />
                    </Stack>
                    <Box sx={{ height: 120 }} />
                </Box>
            </Box>

            <Stack direction="row" spacing={2} sx={{ justifyContent: 'center', pt: 1 }}>
                <Skeleton variant="rounded" width={160} height={40} />
                <Skeleton variant="rounded" width={160} height={40} />
            </Stack>
        </Stack>
    )
}
